import {types} from './types';

const setAuthorizeAction = (payload) => {
    return {
        type: types.SET_AUTHORIZE,
        payload,
      }
}

const setAdminAction = (payload) => {
  return {
    type: types.SET_ADMIN,
    payload
  }
}

export {
  setAuthorizeAction,
  setAdminAction
}
